import React, { useEffect, useState } from 'react'
import './Leftbar.css'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowRightFromBracket,
  faBars,
  faDollarSign,
  faTowerBroadcast,
  faUserAlt,
  faRocket, 
  faAdd
} from '@fortawesome/free-solid-svg-icons'
import { faCommentDots } from '@fortawesome/free-regular-svg-icons'
import logo from '../Images/newlogo.svg'
import { getAuth, signOut } from 'firebase/auth'
import { getDatabase, ref, onValue, set } from 'firebase/database'

function LeftbarUser() {
  const navigate = useNavigate()
  const location = useLocation()
  const auth = getAuth()
  const rtdb = getDatabase()

  const [unreadCount, setUnreadCount] = useState(0)
  const [realUnread, setRealUnread] = useState(0)
  const [pulse, setPulse] = useState(false)

  useEffect(() => {
    const user = auth.currentUser
    if (!user) return

    const chatsRef = ref(rtdb, 'chats')
    const lastReadRefDb = ref(rtdb, 'lastRead')

    let chatsData = {}
    let lastReadData = {}

    const calculateUnread = () => {
      let count = 0
      Object.keys(chatsData).forEach(chatId => {
        if (!chatId.includes(user.uid)) return
        const messages = Object.values(chatsData[chatId] || {})
        const lastRead = lastReadData?.[chatId]?.[user.uid] || 0
        messages.forEach(msg => {
          if (msg.receiverId === user.uid && msg.timestamp > lastRead) count += 1
        })
      })

      // Pulse animation if new message arrived
      if (count > realUnread) {
        setPulse(true)
        setTimeout(() => setPulse(false), 600)
      }

      setRealUnread(count)
      if (location.pathname !== '/user/messages') setUnreadCount(count)
    }

    const unsubChats = onValue(chatsRef, snap => {
      chatsData = snap.val() || {}
      calculateUnread()
    })

    const unsubLastRead = onValue(lastReadRefDb, snap => {
      lastReadData = snap.val() || {}
      calculateUnread()
    })

    // Reset unread when on Messages page
    if (location.pathname === '/user/messages') {
      Object.keys(chatsData).forEach(chatId => {
        if (!chatId.includes(user.uid)) return
        const lastReadRef = ref(rtdb, `lastRead/${chatId}/${user.uid}`)
        set(lastReadRef, Date.now())
      })
      setUnreadCount(0)
    }

    return () => {
      unsubChats()
      unsubLastRead()
    }
  }, [auth, rtdb, location.pathname, realUnread])

  const logoutUser = () => {
    signOut(auth).then(() => navigate('/'))
  }

  return (
    <div className='leftbar'>
      <div className='logocontainer'>
        <img src={logo} />
      </div>

      <div className='leftLinkCont d-flex align-items-center'>
        <NavLink to="/user/dashboard" className='leftNavLinks '>
          <FontAwesomeIcon icon={faBars} className='laftNavIcon' />
          Home
        </NavLink>
      </div>

      <div className='leftLinkCont d-flex align-items-center'>
        <NavLink to="/user/influencers" className='leftNavLinks '>
          <FontAwesomeIcon icon={faRocket} className='laftNavIcon' />
          Influencers
        </NavLink>
      </div>

      <div className='leftLinkCont d-flex align-items-center'>
        <NavLink to="/user/run-ads" className='leftNavLinks '>
          <FontAwesomeIcon icon={faAdd} className='laftNavIcon' />
          Run Ads
        </NavLink>
      </div>

      <div className='leftLinkCont d-flex align-items-center'>
        <NavLink to="/user/ads" className='leftNavLinks '>
          <FontAwesomeIcon icon={faTowerBroadcast} className='laftNavIcon' />
          My Ads
        </NavLink>
      </div>

      <div className='leftLinkCont d-flex align-items-center'>
        <NavLink to="/user/messages" className='leftNavLinks '>
          <FontAwesomeIcon icon={faCommentDots} className='laftNavIcon' />
          Messages
          {unreadCount > 0 && (
            <span className={`messageBadge ${pulse ? 'pulse' : ''}`}>
              {unreadCount}
            </span>
          )}
        </NavLink>
      </div>

      <div className='leftLinkCont d-flex align-items-center'>
        <NavLink to="/user/profile" className='leftNavLinks '>
          <FontAwesomeIcon icon={faUserAlt} className='laftNavIcon' />
          Profile
        </NavLink>
      </div>

      <hr />

      <div className='logoutMenu' onClick={logoutUser}>
        <div className='leftLinkCont d-flex align-items-center'>
          <div className='leftNavLinks logoutbtn'>
            <FontAwesomeIcon icon={faArrowRightFromBracket} className='laftNavIcon' />
            Logout
          </div>
        </div>
      </div>
    </div>
  )
}

export default LeftbarUser 